import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { PlayEventNames } from '../types';

type PlayEventPayload = Pick<
  TrackEventProperties,
  | 'playId'
  | 'playbookId'
  | 'tourId'
  | 'demoId'
  | 'externalUrlId'
  | 'organizationId'
  | 'workspaceId'
  | 'playSource'
>;

type EventName = keyof typeof PlayEventNames;
type FunctionName =
  `track${Capitalize<CamelCase<keyof typeof PlayEventNames>>}`;
const functionNameEntries = Object.keys(PlayEventNames).map((eventName) => [
  eventName as EventName,
  `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}` as FunctionName,
]);

export const usePlayAnalytics = (
  location: string,
  commonPayload?: PlayEventPayload
) => {
  const { trackEvent } = useAnalytics();

  return Object.fromEntries(
    functionNameEntries.map(([eventName, functionName]) => [
      functionName,
      (payload?: PlayEventPayload) => {
        trackEvent(PlayEventNames[eventName], {
          ...commonPayload,
          ...payload,
          location,
        });
      },
    ])
  ) as {
    [K in FunctionName]: (payload?: PlayEventPayload) => void;
  };
};
